import { ServiceStackType } from '@zerops/models/service-stack';
import { Country, Currency, Language, Location } from '@zerops/models/settings';

export class SettingsBaseState {
  countryList: Country[];
  currencyList: Currency[];
  languageList: Language[];
  serviceStackList: ServiceStackType[];
  activeCurrency: Currency;
  locationList: Location[];
  locationPingMap: Record<string, number | null>;
  fastestLocationId: string | null;
  stackTypeDetailMap: Record<string, ServiceStackType>;

  constructor() {
    this.countryList = [];
    this.currencyList = [];
    this.languageList = [];
    this.serviceStackList = [];
    this.activeCurrency = { id: 'USD', symbol: '$', displaySymbolBefore: true, roundDigits: 4 };
    this.locationList = [];
    this.locationPingMap = {};
    this.fastestLocationId = null;
    this.stackTypeDetailMap = {};
  }
}
